<template>
	<div class="review-box-header">
		<div class="review-box-header__info">
			<ReviewerInfo :review="review" />
			<RatingBox
				:rating="rating"
				theme="normal"
			/>
		</div>
		<div class="review-box-header__text-content">
			<h4 class="review-box-header__title">
				{{ review.Headline }}
			</h4>
			<p class="review-box-header__text">
				{{ review.Conclusion }}
			</p>
		</div>
	</div>
</template>

<script lang="ts" setup>
import { computed } from 'vue';

import { RATING_MAX_VALUE } from '@global-js/constants';
import ReviewerInfo from './ReviewerInfo.vue';
import { ReviewType } from '@/interfaces/review-types';
import RatingBox from './RatingBox.vue';
import { numberFormat } from '@/js/utils/numberUtils';

interface Props {
	review: ReviewType
}
const props = defineProps<Props>();

const rating = computed(() => `${numberFormat(props.review.RatingOverallValue)}/${RATING_MAX_VALUE}`);
</script>

<style lang="scss" scoped>
.review-box-header {
	& > * {
		margin: 0;
		padding: 0;
	}

	&__info {
		display: flex;
		align-items: flex-start;
		justify-content: space-between;
	}

	&__title {
		margin: 0 0 0.4rem !important;
	}

	&__text-content {
		margin-top: 0.8rem !important;
		display: flex;
		flex-flow: column;
		flex-grow: 1;
		font-size: $font-small-2;

		.review-box-header__title {
			font-size: $font-small-1;
			font-weight: $font-weight-semibold;
		}
	}

	&__text {
		display: -webkit-box;
		-webkit-line-clamp: 4;
		-webkit-box-orient: vertical;
		overflow: hidden;
		text-overflow: ellipsis;
		margin: 0.4rem 0;
		line-height: $line-height-text;
	}
}
</style>
